import _ from 'lodash'
import ObjectBooking from 'utils/objects/booking'
import Translate from 'utils/translate'
import { dateFormat } from 'utils/helper-date'

export const filterBookingEmployees = ( employees, query = null ) => {
	return (
		_.toArray(
			_.filter( employees, item => {
				return ( query === null || _.isEmpty( query ) ) ? true : _.includes( _.get( item, ['name'], '' ).toLowerCase(), query )
			})
		)
	);
}

export const createBookingList = ( employeeBookings, { hideNotScannedIn = false, showInvitationsOnly = false, showEroOnly = false } = {}) => {
	employeeBookings = _.filter( employeeBookings, (o) => {
		return _.get( o, 'guid', null ) !== null
	});
	
	// Create the employees list
	let employees = {};
	
	// Create bookings list
	const { list: bookingsList, bookings } = ObjectBooking.group( employeeBookings, { hideNotScannedIn: hideNotScannedIn, showInvitationsOnly: showInvitationsOnly, showEroOnly: showEroOnly } );
	
	// Group the bookings
	const list = (
		_.orderBy(
			_.map( bookingsList, group => {
				// Create the constants
				let groupConstants = {};
				
				// Create the booking list
				const bookings = _.orderBy(
					_.map( group, item => {
						const timeslotStart = item.data.startTime.format( dateFormat.SHORT_TIME );
						const timeslotEnd = item.data.endTime.format( dateFormat.SHORT_TIME );
						
						// Create the constants
						if( _.isEmpty( groupConstants ) ) {
							// Create the title
							const title = _.reject( [ Translate.field( item.data.floor, 'name' ), Translate.field( item.data.room, 'name' ) ], _.isNull );
							
							const groupTitle = _.size( title ) > 0 ? title.join( ' - ' ) : null
							
							//
							groupConstants = {
								guid: `${groupTitle}-${item.data.booking_date}`,
								title: groupTitle,
								kind: item.data?.kind,
								booking_date: item.data.booking_date,
								sort1: _.get( item.data.floor, 'position', 0 ),
								sort2: _.get( item.data.room, 'position', 0 ),
							}
						}
						
						// Invitation?
						const bookingInvitation = _.get( item.data, 'bookingInvitation', null );
						
						// Employees
						_.forEach( item.employees, employee => {
							const employeeGuid = _.get( employee, 'guid', null );
							if( employeeGuid !== null && !_.has( employees, employeeGuid ) ) {
								employees[ employeeGuid ] = employee;
							}
						})
						
						const title = `${ timeslotStart } - ${ timeslotEnd }`
						
						return {
							guid: `${title}-${item.data.booking_date}`,
							title: title,
							timeslot_start: timeslotStart,
							booking_date: item.data.booking_date,
							booking_invitation: bookingInvitation,
							booking_count: _.size( item.timeslots ),
							data: _.toArray( item.employees )
						}
					} ),
					'timeslot_start',
					'asc'
				);
				
				return {
					...groupConstants,
					bookings: bookings
				}
			}),
			['sort1', 'sort2'],
			['asc', 'asc']
		)
	)
	
	// And give the result
	return {
		employees: employees,
		employeesFiltered: filterBookingEmployees( employees ),
		list: list,
		bookings: bookings
	};
}

